const colors = {
  neutral100: "#F7F4F1",
  neutral900: "#EBE3DB",
  darkOlive100: "#A7AA9E",
  darkOlive900: "#222B0D",
};

export default colors;
